import { render, staticRenderFns } from "./CreatePopup.vue?vue&type=template&id=497fe5d9"
import script from "./CreatePopup.vue?vue&type=script&lang=js"
export * from "./CreatePopup.vue?vue&type=script&lang=js"
import style0 from "./CreatePopup.vue?vue&type=style&index=0&id=497fe5d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports